module.exports = __webpack_public_path__ + "static/media/italian.ae259065.png";